import React from "react";

import styles from "./UploadSpinner.module.scss";

function UploadSpinner() {
  return <div className={styles.loader}></div>;
}

export default UploadSpinner;
